import {
  type UseMutationOptions,
  type UseMutationResult,
  useMutation,
} from '@tanstack/react-query';
import { z } from 'zod';
import { fetcher } from '../../../../utils/api/fetcher/fetcher';
import type { ApiError } from '../../../../utils/api/ApiError/ApiError';
import {
  permissionsShape,
  type Permissions,
} from '../use-get-permissions-api/use-get-permissions-api';

interface UpdateUserPermissionsArgs {
  orgId: string | undefined;
  userId: string | undefined;
  updatedPermissions: Permissions;
}

const updatePermissionsResponseShape = z.object({
  permissions: permissionsShape,
});

export async function updateUserPermissionsApi({
  orgId,
  userId,
  updatedPermissions,
}: UpdateUserPermissionsArgs): Promise<Permissions> {
  const newPermissions = await fetcher<Permissions>(
    `/user-permissions/user/${userId}/org/${orgId}`,
    {
      service: '/permissions',
      version: '/v2',
      method: 'PUT',
      body: JSON.stringify(updatedPermissions),
    }
  );

  return updatePermissionsResponseShape.parse(newPermissions).permissions;
}

export function useUpdateUserPermissionsApi(
  customMutationOptions?: UseMutationOptions<
    Permissions,
    ApiError,
    UpdateUserPermissionsArgs
  >
): UseMutationResult<Permissions, ApiError, UpdateUserPermissionsArgs> {
  return useMutation({
    mutationFn: (args) => updateUserPermissionsApi(args),
    ...customMutationOptions,
  });
}
